export default __webpack_public_path__ + "static/media/1536.48056ca5.png";